import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleHolderEditorComponent } from './role-holder-editor/role-holder-editor.component';
import { TranslocoModule } from '@jsverse/transloco';
import { AvatarsModule, EmailInputFormModule } from '@frontend/shared';
import { AlertModule } from 'ngx-bootstrap/alert';



@NgModule({
  declarations: [
    RoleHolderEditorComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    AvatarsModule,
    EmailInputFormModule,
    AlertModule
  ],
  exports: [
    RoleHolderEditorComponent
  ]
})
export class RoleHoldersModule { }
